import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../../shared/tabs.component';

import ProposedSubledgerJournalGrid, { slJournalPropTypes } from '../common/proposedSubledgerJournalGrid.component';
import ProposedSubledgerBalanceGrid, { slDeferredBalancePropTypes } from '../common/proposedSubledgerBalanceGrid.component';

export const proposedJournalsPropTypes = PropTypes.shape({
  slJournal: slJournalPropTypes,
  slDeferredBalance: slDeferredBalancePropTypes,
  allowGross: PropTypes.bool,
});

const TabTypes = {
  SL_JOURNAL: 'SL_JOURNAL',
  SL_BALANCE: 'SL_BALANCE',
};

class ViewJournalGrids extends PureComponent {
  static propTypes = {
    proposedJournals: proposedJournalsPropTypes,
    allowGross: PropTypes.bool,
  };

  state = {
    activeTab: TabTypes.SL_JOURNAL,
  };

  changeTab = (event, tabType) => {
    this.setState({
      activeTab: tabType,
    });

    this.proposedSubledgerBalanceGridApi.sizeColumnsToFit();
  };

  onProposedSubledgerBalanceGridReady = ({ api }) => {
    this.proposedSubledgerBalanceGridApi = api;
  };

  render() {
    const { activeTab } = this.state;
    const { slJournal, slDeferredBalance, allowGross } = this.props.proposedJournals;

    return (
      <div className="view-journal-grids page-content-container">
        <Tabs
          defaultValue={TabTypes.SL_JOURNAL}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.SL_JOURNAL} label="Proposed Subledger Journals">
            {slJournal ? (
              <ProposedSubledgerJournalGrid
                slJournal={slJournal}
                allowGross={allowGross}
              />
            ) : 'No Subledger Journals Available'}
          </Tab>
          <Tab value={TabTypes.SL_BALANCE} label="Proposed Subledger Balances">
            {slDeferredBalance ? (
              <ProposedSubledgerBalanceGrid
                slDeferredBalance={slDeferredBalance}
                allowGross={allowGross}
                onGridReady={this.onProposedSubledgerBalanceGridReady}
              />
            ) : 'No Subledger Balances Available'}
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default ViewJournalGrids;
